import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jgpbfm8d3: FaireProductEntity = {
  token: "p_6jgpbfm8d3",
  type: "product",
  name: "Halloween Spooky Casual Socks",
  brandToken: "b_7didlift8g",
  brandName: "Tiepology",
  imageUrl:
    "https://cdn.faire.com/fastly/d32177293a97d239588bd16774ec72d71d54e4fba3bccd5ef2ee75e9b2878070.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30ed63fe0a8dd1b7c568a99a89c7919712add0613421d7a9f89645185bb55d9b.jpeg",
    "https://cdn.faire.com/fastly/8ec30e5e0c32534ffb53f29daf489ee15e43289a5b89266ecc5dce6ccc89cc78.jpeg",
  ],
  priceDollars: 3.95,
  description:
    "• Adult Size\n• 80% Cotton, 10% Spandex, 10% Polyester\n• Machine Wash\n\nThese Halloween casual socks are expertly designed with a festive and fun print for the holiday season. Made with high-quality materials, they provide both comfort and style. Perfect for adding a touch of Halloween spirit to any outfit, these socks are a must-have for any Halloween enthusiast.",
  tags: [],
  msrpDollars: 7.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:36.302Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
